import React from 'react';

export const countries = {
  "GBP": {
    name: "United Kingdom",
    iso2: "gb",
    dialCode: "44",
    priority: 0,
    areaCodes: null,
  },
  "USD": {
    areaCodes: null,
    dialCode: "1",
    iso2: "us",
    name: "United States",
    priority: 0
  },
  "CAD": {
    areaCodes: null,
    dialCode: "1",
    iso2: "ca",
    name: "Canada",
    priority: 0
  },
  "AUS": {
    areaCodes: null,
    dialCode: "61",
    iso2: "au",
    name: "Australia",
    priority: 0
  }
};

export const getPreferredCountries = () => {
  return ["us", "gb", "ca", "au"];
  // const {fabricatorState} = store.getState();
  // if (fabricatorState.isCaesarStone) {
  //   return ["au", "us", "gb", "ca"]
  // }
  // switch(fabricatorState.settings.currency) {
  //   case "CAD":
  //     return fabricatorState.isLowes ? ["ca"] : ["ca", "gb", "us"];
  //   default:
  //     return ["us", "gb", "ca"];
  // }
}

export const getDefaultCountry = () => {
  return "auto";
  // const {fabricatorState} = store.getState();
  // if (fabricatorState.isLowes) {
  //   return countries.CAD
  // }
  // // const {intl} = this.props;
  // // if (intl.locale === "en-AU" || this.props.fabricatorData.isCaesarStone) {
  // if (fabricatorState.isCaesarStone) {
  //   return countries.AUS
  // }
  // return countries[fabricatorState.settings.currency] || 'auto'
};
